/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UpdateDocumentInput = {
    clientMutationId: string;
    description?: string | null;
    documentId: string;
    props?: unknown | null;
    statusId?: string | null;
    statusIdentifier?: string | null;
    tenantId: string;
    title?: string | null;
};
export type useDashboardUpdateDocumentMutationVariables = {
    input: UpdateDocumentInput;
};
export type useDashboardUpdateDocumentMutationResponse = {
    readonly updateDocument: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
        } | null> | null;
        readonly document: {
            readonly id: string;
            readonly status: {
                readonly id: string;
                readonly name: string;
            };
        } | null;
    } | null;
};
export type useDashboardUpdateDocumentMutation = {
    readonly response: useDashboardUpdateDocumentMutationResponse;
    readonly variables: useDashboardUpdateDocumentMutationVariables;
};



/*
mutation useDashboardUpdateDocumentMutation(
  $input: UpdateDocumentInput!
) {
  updateDocument(input: $input) {
    errors {
      code
      path
      message
    }
    document {
      id
      status {
        id
        name
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpdateDocumentPayload",
            "kind": "LinkedField",
            "name": "updateDocument",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "InputError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Document",
                    "kind": "LinkedField",
                    "name": "document",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Status",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useDashboardUpdateDocumentMutation",
            "selections": (v2 /*: any*/),
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useDashboardUpdateDocumentMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "cacheID": "9a7233ea38daa2d03f0137245d9f0cb4",
            "id": null,
            "metadata": {},
            "name": "useDashboardUpdateDocumentMutation",
            "operationKind": "mutation",
            "text": "mutation useDashboardUpdateDocumentMutation(\n  $input: UpdateDocumentInput!\n) {\n  updateDocument(input: $input) {\n    errors {\n      code\n      path\n      message\n    }\n    document {\n      id\n      status {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '78642bd0d5e47105c899650f466b67c3';
export default node;
